module.exports = __webpack_public_path__ + "static/media/bg-popup-invite.d46791c1.png";